import React, { FC, useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { CreateSfWalletRequestDto } from '@sparling/financial-common'
import { endOfDay, startOfDay } from 'date-fns'
import { DataPicker } from '../../../../components/DatePicker'
import { Search } from '../../../../components/Search'
import { FilterSelect } from '../../../../components/FilterSelect'
import { ADDRESS_PROTOCOL } from '../../../../constants/crmCurrencies'
import { getSfWalletsRequest, resetSfWalletFilters } from '../../../../store/actions'
import { availableCryptoCurrenciesEnumSelector } from '../../../../store/selectors'

interface IFiltersFields {
  fromDate?: string
  toDate?: string
  currency?: string
  search?: string
}

export const WalletsFilters: FC = () => {
  const dispatch = useDispatch()
  const availableCryptoCurrencies = useSelector(availableCryptoCurrenciesEnumSelector)
  const formMethods = useForm<IFiltersFields>({ mode: 'onChange' })
  const { watch, getValues } = formMethods

  useEffect(() => {
    dispatch(resetSfWalletFilters())
  }, [dispatch])

  useEffect(() => {
    const subscription = watch(() => {
      dispatch(getSfWalletsRequest(getValues() as CreateSfWalletRequestDto))
    })

    return () => subscription.unsubscribe()
  }, [dispatch, getValues, watch])

  return (
    <FormProvider {...formMethods}>
      <DataPicker
        placeholder={'Start Date'}
        margin={'0 8px'}
        dataPickerName={'fromDate'}
        required={false}
        maxDate={getValues().toDate}
        formatValue={startOfDay}
      />
      <DataPicker
        placeholder={'End Date'}
        margin={'0 8px'}
        dataPickerName={'toDate'}
        required={false}
        minDate={getValues().fromDate}
        formatValue={endOfDay}
      />
      <FilterSelect
        inputName="currency"
        placeholder="Currency"
        enums={availableCryptoCurrencies}
        mr={8}
        ml={8}
        width={138}
      />
      <FilterSelect
        inputName="addressProtocol"
        placeholder="Address Protocol"
        enums={ADDRESS_PROTOCOL}
        mr={8}
        ml={8}
        width={158}
      />
      <Search inputName={'search'} />
    </FormProvider>
  )
}
